import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect, useCallback } from "react";
export function MessageInput({ onSend, disabled, prefill }) {
    const [text, setText] = useState("");
    const textareaRef = useRef(null);
    // Apply prefill when it changes and the input is empty
    useEffect(() => {
        if (prefill && !text) {
            setText(prefill);
            requestAnimationFrame(() => autoGrow());
        }
    }, [prefill]);
    // Auto-grow textarea height to fit content (capped by CSS max-height)
    const autoGrow = useCallback(() => {
        const el = textareaRef.current;
        if (!el)
            return;
        el.style.height = "auto";
        el.style.height = `${el.scrollHeight}px`;
    }, []);
    // Re-focus the textarea when it becomes enabled again
    useEffect(() => {
        if (!disabled) {
            textareaRef.current?.focus();
        }
    }, [disabled]);
    const handleSubmit = (e) => {
        e.preventDefault();
        const trimmed = text.trim();
        if (!trimmed || disabled)
            return;
        onSend(trimmed);
        setText("");
        // Reset height after clearing
        requestAnimationFrame(() => {
            const el = textareaRef.current;
            if (el)
                el.style.height = "auto";
        });
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };
    return (_jsx("form", { className: "message-input", onSubmit: handleSubmit, children: _jsxs("div", { className: "message-input-wrapper", children: [_jsx("textarea", { ref: textareaRef, value: text, onChange: (e) => {
                        setText(e.target.value);
                        autoGrow();
                    }, onKeyDown: handleKeyDown, placeholder: "Type a message\u2026", disabled: disabled, rows: 1 }), _jsx("button", { type: "submit", disabled: disabled || !text.trim(), title: "Send", children: "\u2191" })] }) }));
}
//# sourceMappingURL=MessageInput.js.map